export enum KrampPriceExportStateValues {
  MS_IDLE = 'MS_IDLE',
  MS_DATA_READY = 'MS_DATA_READY',
  MS_RUNNING_EXPORT = 'MS_RUNNING_EXPORT',
}

export interface KrampPriceExportState {
  state: KrampPriceExportStateValues;
  comment: string;
  updatedBy: string;
  updatedAt: Date;
}

export interface KrampPriceExportStateForUpdate {
  state: KrampPriceExportStateValues;
  comment: string;
  updatedByHint: string;
}
